import css from '@emotion/css/macro'
import styled from '@emotion/styled/macro'
import { ifProp } from 'mixins'
import { ISearchBoxProps, SearchBox } from 'office-ui-fabric-react'
import * as React from 'react'

const StyledSearchBox = styled(SearchBox)`
  height: 100%;
  margin-left: -24px;
  margin-right: 8px;
  border: 0;

  ${ifProp(
    (props) => props.value,
    css`
      .ms-SearchBox-iconContainer {
        width: 0 !important;
        i {
          opacity: 0 !important;
        }
      }
    `,
    css`
      .ms-SearchBox-iconContainer {
        width: 28px !important;
        i {
          opacity: 1 !important;
        }
      }
    `
  )}

  .ms-SearchBox-field {
    padding-left: 4px;
  }
`

export const CommandBarSearchBox: React.FunctionComponent<ISearchBoxProps> = (
  props
) => <StyledSearchBox {...props} />
